import styled from 'styled-components';

import { GhostButton } from 'ui/button';
import { Link } from 'ui/links';
import { colors, caption, spacing } from 'ui/theme';

export const StyledButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: ${spacing.base};
  justify-content: center;
`;

export const StyledSeeMoreButton = styled(GhostButton)`
  display: flex;
  align-items: center;
  background: none;
  color: ${colors.textSecondary};
  border: none;
  :hover {
    color: ${colors.textPrimary};
  }
  width: 100%;
`;

// Link styles is to not match existing Link themes
export const StyledPopoverBodyLink = styled(Link)`
  padding-right: ${spacing.quarter};
`;

export const StyledPopoverLinkText = styled.div`
  ${caption};
  color: ${colors.textDisabled};
  padding-top: ${spacing.half};
`;

export const StyledSeeMoreText = styled.span`
  color: ${colors.textDisabled};

  &[data-hovered='true'] {
    color: ${colors.textPrimary};
  }
`;
